<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingSalesDataEditData"
  >
    <form
      autocomplete="off"
      @submit.prevent="updatePuntoVenta"
    >
      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-info"></i>
          </span>
          {{ $t('mEditionBillingSalesDataEditData.fieldsets.legends.general') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-5">
              <AtomInputPrimary
                v-model="datos.punto_venta.nombre"
                :input-error="$v.datos.punto_venta.nombre.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.nombre.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.nombre.message')"
                :message-error="messageErrorNombre"
                name="nombre"
                reference="nombre"
                :placeholder="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.nombre.placeholder')"
                type="text"
                @blur="$v.datos.punto_venta.nombre.$touch()"
              />
            </div>
            <div class="column column-5">
              <AtomLogoEdition
                entity="punto_venta"
                clase="billing"
                :logo-img="datos.punto_venta.imagen"
                @changeLogoImage="changeLogoImage"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          {{ $t('mEditionBillingSalesDataEditData.fieldsets.legends.location') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimaryTimeout
                v-model.number="datos.domicilio.pais"
                :elements="paises"
                :input-error="$v.datos.domicilio.pais.$error"
                key-field="id_pais"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.pais.label')"
                :message-error="messageErrorPais"
                name="pais"
                reference="pais"
                text-field="nombre"
                @blur="$v.datos.domicilio.pais.$touch()"
                @input="readComprobanteTipos(); readParametroDocumentoTipos(); readParametroProvincias()"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.domicilio.provincia"
                :elements="provincias"
                :input-error="$v.datos.domicilio.provincia.$error"
                key-field="id_provincia"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.provincia.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.domicilio.provincia.message')"
                :message-error="messageErrorProvincia"
                name="provincia"
                reference="provincia"
                text-field="nombre"
                @blur="$v.datos.domicilio.provincia.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.domicilio.localidad"
                :input-error="$v.datos.domicilio.localidad.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.localidad.label')"
                :message-error="messageErrorLocalidad"
                :message="$t('mEditionBillingSalesDataEditData.inputs.domicilio.localidad.message')"
                name="localidad"
                reference="localidad"
                type="text"
                @blur="$v.datos.domicilio.localidad.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-2">
              <AtomInputPrimary
                v-model="datos.domicilio.codigo_postal"
                :input-error="$v.datos.domicilio.codigo_postal.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.codigo_postal.label')"
                :message-error="messageErrorCodigoPostal"
                :message="$t('mEditionBillingSalesDataEditData.inputs.domicilio.codigo_postal.message')"
                name="codigo_postal"
                reference="codigo_postal"
                type="text"
                @blur="$v.datos.domicilio.codigo_postal.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.domicilio.linea1"
                :input-error="$v.datos.domicilio.linea1.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.linea1.label')"
                :message-error="messageErrorLinea1"
                :message="$t('mEditionBillingSalesDataEditData.inputs.domicilio.linea1.message')"
                name="linea1"
                reference="linea1"
                type="text"
                @blur="$v.datos.domicilio.linea1.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.domicilio.linea2"
                :input-error="$v.datos.domicilio.linea2.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.domicilio.linea2.label')"
                :message-error="messageErrorLinea2"
                :message="$t('mEditionBillingSalesDataEditData.inputs.domicilio.linea2.message')"
                name="linea2"
                reference="linea2"
                type="text"
                @blur="$v.datos.domicilio.linea2.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-file-invoice"></i>
          </span>
          {{ $t('mEditionBillingSalesDataEditData.fieldsets.legends.invoice') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.punto_venta.comprobante_tipo"
                :input-error="$v.datos.punto_venta.comprobante_tipo.$error"
                :elements="comprobanteTipos"
                keyField="id_comprobante_tipo"
                :label="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.comprobante_tipo.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.comprobante_tipo.message')"
                :message-error="messageErrorComprobanteTipo"
                name="comprobante_tipo"
                reference="comprobante_tipo"
                text-field="nombre"
                @blur="$v.datos.punto_venta.comprobante_tipo.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.punto_venta.numero"
                :input-error="$v.datos.punto_venta.numero.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.numero.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.numero.message')"
                :message-error="messageErrorNumero"
                :disabled="true"
                name="numero"
                reference="numero"
                :tooltip="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.numero.tooltip')"
                type="text"
                @blur="$v.datos.punto_venta.numero.$touch()"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.punto_venta.divisa"
                :elements="divisas"
                :input-error="$v.datos.punto_venta.divisa.$error"
                key-field="iso_code"
                :label="datos.punto_venta.comprobante_tipo && datos.punto_venta.comprobante_tipo !== 1 ? $t('mEditionBillingSalesDataEditData.inputs.punto_venta.divisa_emite.label') : $t('mEditionBillingSalesDataEditData.inputs.punto_venta.divisa.label')"
                :message-error="messageErrorDivisa"
                :disabled="true"
                name="divisa"
                reference="divisa"
                text-field="nombre"
                @blur="$v.datos.punto_venta.divisa.$touch()"
              />
            </div>
          </div>

          <div
            v-if="datos.punto_venta.comprobante_tipo && datos.punto_venta.comprobante_tipo !== 1"
            class="row"
          >
            <div class="column column-10">
              <p class="a-input-wrapper-column margin-bottom-medium">
                <label>
                  {{ $t('mEditionBillingSalesDataCreateData.inputs.punto_venta.divisa_vende.label') }}
                </label>
                <span class="display-flex-row">
                  <span
                    v-for="divisa in divisas"
                    :key="divisa.id"
                  >
                    <AtomCheckboxPrimary
                      v-model="datos.punto_venta.divisa_vende"
                      :disabled="buttonPrimary.sending"
                      inputStyle="billing"
                      :name="`mediodepago-${divisa.id}[]`"
                      :text="divisa.nombre"
                      :value="divisa.iso_code"
                      wrapperClass="margin-right-medium margin-top-small"
                    />
                  </span>
                </span>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="column column-10">
              <AtomTextAreaPrimary
                v-model="datos.punto_venta.mensaje_pie"
                :input-error="$v.datos.punto_venta.mensaje_pie.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.mensaje_pie.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.punto_venta.mensaje_pie.message')"
                :message-error="messageErrorMensajePie"
                name="mensaje_pie"
                reference="mensaje_pie"
                type="text"
                @blur="$v.datos.punto_venta.mensaje_pie.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-balance-scale"></i>
          </span>
          {{ $t('mEditionBillingSalesDataEditData.fieldsets.legends.legal') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="datos.persona.fisica"
                :input-error="$v.datos.persona.fisica.$error"
                :elements="personas"
                key-field="id"
                :label="$t('mEditionBillingSalesDataEditData.inputs.persona.fisica.label')"
                :message-error="messageErrorFisica"
                name="fisica"
                reference="fisica"
                text-field="nombre"
                @blur="$v.datos.persona.fisica.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="datos.persona.razon_social"
                :input-error="$v.datos.persona.razon_social.$error"
                :label="datos.persona.fisica === 0
                  ? $t('mEditionBillingSalesDataEditData.inputs.persona.razon_social.labelBusiness')
                  : $t('mEditionBillingSalesDataEditData.inputs.persona.razon_social.labelName')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.persona.razon_social.message')"
                :message-error="messageErrorRazonSocial"
                name="razon_social"
                reference="razon_social"
                type="text"
                @blur="$v.datos.persona.razon_social.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="datos.persona.documento_tipo"
                :elements="documentoTipos"
                :input-error="$v.datos.persona.documento_tipo.$error"
                key-field="id_documento_tipo"
                :label="$t('mEditionBillingSalesDataEditData.inputs.persona.documento_tipo.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.persona.documento_tipo.message')"
                :message-error="messageErrorDocumentoTipo"
                name="documento_tipo"
                reference="documento_tipo"
                text-field="nombre"
                @blur="$v.datos.persona.documento_tipo.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="datos.persona.documento_numero"
                :input-error="$v.datos.persona.documento_numero.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.persona.documento_numero.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.persona.documento_numero.message')"
                :message-error="messageErrorDocumentoNumero"
                name="documento_numero"
                reference="documento_numero"
                type="text"
                @blur="$v.datos.persona.documento_numero.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-mobile-alt"></i>
          </span>
          {{ $t('mEditionBillingSalesDataEditData.fieldsets.legends.contact') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-5">
              <AtomInputPrimary
                v-model="datos.persona.telefono"
                :input-error="$v.datos.persona.telefono.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.persona.telefono.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.persona.telefono.message')"
                :message-error="messageErrorTelefono"
                name="telefono"
                reference="telefono"
                type="text"
                @blur="$v.datos.persona.telefono.$touch()"
              />
            </div>

            <div class="column column-5">
              <AtomInputPrimary
                v-model="datos.persona.movil"
                :input-error="$v.datos.persona.movil.$error"
                :label="$t('mEditionBillingSalesDataEditData.inputs.persona.movil.label')"
                :message="$t('mEditionBillingSalesDataEditData.inputs.persona.movil.message')"
                :message-error="messageErrorMovil"
                name="movil"
                reference="movil"
                type="text"
                @blur="$v.datos.persona.movil.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="m-form-action">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingSalesDataEditData',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingSalesDataEditData.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      comprobanteTipos: [],

      datos: {
        punto_venta: {
          comprobante_tipo: '',
          divisa: '',
          divisa_vende: [],
          mensaje_pie: '',
          nombre: '',
          numero: '',
          imagen: ''
        },
        domicilio: {
          codigo_postal: '',
          linea1: '',
          linea2: '',
          localidad: '',
          pais: '',
          provincia: ''
        },
        persona: {
          documento_numero: '',
          documento_tipo: '',
          fisica: 1,
          movil: '',
          razon_social: '',
          telefono: ''
        }
      },

      divisas: [],
      documentoTipos: [],

      isDivisaDisabled: false,

      personas: [
        {
          id: 0,
          nombre: 'Persona Jurídica'
        },

        {
          id: 1,
          nombre: 'Persona Física'
        }
      ],

      paises: [],
      puntoVenta: {},
      puntoVentaId: '',
      provincias: [],
      showLoadingState: 0
    }
  },

  validations: {
    datos: {
      domicilio: {
        codigo_postal: {
          maxLength: maxLength(10),
          minLength: minLength(1),
          required
        },

        linea1: {
          maxLength: maxLength(120),
          minLength: minLength(1),
          required
        },

        linea2: {
          maxLength: maxLength(120),
          minLength: minLength(1)
        },

        localidad: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        pais: {
          required
        },

        provincia: {
          required
        }
      },

      persona: {
        documento_numero: {
          maxLength: maxLength(45),
          minLength: minLength(1),
          required
        },

        documento_tipo: {
          required
        },

        fisica: {
          required
        },

        movil: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        razon_social: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        telefono: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        }
      },

      punto_venta: {
        comprobante_tipo: {
          required
        },

        divisa: {
          required
        },

        mensaje_pie: {
          maxLength: maxLength(255),
          minLength: minLength(1),
          required
        },

        nombre: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        numero: {
          minLength: minLength(1),
          maxLength: maxLength(10),
          required
        }
      }
    }
  },

  computed: {
    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.codigo_postal, 'domicilio', 'codigo_postal')
    },

    messageErrorComprobanteTipo () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.punto_venta.comprobante_tipo, 'punto_venta', 'comprobante_tipo')
    },

    messageErrorDivisa () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.punto_venta.divisa, 'punto_venta', 'divisa')
    },

    messageErrorDocumentoNumero () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.documento_numero, 'persona', 'documento_numero')
    },

    messageErrorDocumentoTipo () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.documento_tipo, 'persona', 'documento_tipo')
    },

    messageErrorFisica () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.fisica, 'persona', 'fisica')
    },

    messageErrorLinea1 () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.linea1, 'domicilio', 'linea1')
    },

    messageErrorLinea2 () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.linea2, 'domicilio', 'linea2')
    },

    messageErrorLocalidad () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.localidad, 'domicilio', 'localidad')
    },

    messageErrorMensajePie () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.punto_venta.mensaje_pie, 'punto_venta', 'mensaje_pie')
    },

    messageErrorMovil () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.movil, 'persona', 'movil')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.punto_venta.nombre, 'punto_venta', 'nombre')
    },

    messageErrorNumero () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.punto_venta.numero, 'punto_venta', 'numero')
    },

    messageErrorPais () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.pais, 'domicilio', 'pais')
    },

    messageErrorProvincia () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.domicilio.provincia, 'domicilio', 'provincia')
    },

    messageErrorRazonSocial () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.razon_social, 'persona', 'razon_social')
    },

    messageErrorTelefono () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataEditData', this.$v.datos.persona.telefono, 'persona', 'telefono')
    }
  },

  created () {
    this.puntoVentaId = this.$route.params.subid
    this.readDivisas()
    this.readPuntoVenta()
    this.readParametroPaises()
  },

  methods: {
    changeLogoImage (logoImg) {
      this.datos.punto_venta.imagen = logoImg
    },

    readComprobanteTipos () {
      this.$services.read('comprobante', 'readComprobanteTipos', {}, [this.datos.domicilio.pais])
        .then(response => {
          this.comprobanteTipos = response.data
          if (this.datos.punto_venta.divisa !== 'EUR') {
            this.comprobanteTipos = this.comprobanteTipos.filter((c) => {
              return c.id_comprobante_tipo === 1
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroDocumentoTipos () {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [this.datos.domicilio.pais])
        .then(response => {
          this.documentoTipos = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroProvincias () {
      this.$services.read('parametro', 'readParametroProvincias', {}, [this.datos.domicilio.pais])
        .then(response => {
          this.provincias = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPuntoVenta () {
      this.$services.read('puntoVenta', 'readPuntoVenta', {}, [this.puntoVentaId])
        .then(response => {
          Object.assign(this.puntoVenta, response.data)
          this.datos.punto_venta.nombre = response.data.nombre
          this.datos.punto_venta.mensaje_pie = response.data.mensaje_pie
          this.datos.punto_venta.comprobante_tipo = response.data.comprobante_tipo
          this.datos.punto_venta.numero = response.data.numero
          this.datos.punto_venta.imagen = response.data.logo
          this.datos.punto_venta.divisa = this.divisas.find(d => d.id_divisa === response.data.divisa.id_divisa).iso_code
          this.datos.punto_venta.divisa_vende = response.data.divisa_vende
          this.datos.domicilio.linea1 = response.data.persona_facturacion.domicilio.linea1
          this.datos.domicilio.linea2 = response.data.persona_facturacion.domicilio.linea2
          this.datos.domicilio.localidad = response.data.persona_facturacion.domicilio.localidad
          this.datos.domicilio.codigo_postal = response.data.persona_facturacion.domicilio.codigo_postal
          this.datos.domicilio.pais = response.data.persona_facturacion.domicilio.provincia.pais.id_pais
          this.datos.domicilio.provincia = response.data.persona_facturacion.domicilio.provincia.id_provincia

          this.datos.persona.razon_social = response.data.persona_facturacion.razon_social
          this.datos.persona.fisica = response.data.persona_facturacion.fisica ? 1 : 0
          this.datos.persona.telefono = response.data.persona_facturacion.telefono
          this.datos.persona.movil = response.data.persona_facturacion.movil
          this.datos.persona.documento_numero = response.data.persona_facturacion.documento.numero
          this.datos.persona.documento_tipo = response.data.persona_facturacion.documento.tipo.id_documento_tipo

          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    updatePuntoVenta () {
      this.$v.$touch()
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.update('puntoVenta', 'updatePuntoVenta', this.datos, [this.puntoVentaId])
          .then(response => {
            this.datos.punto_venta.nombre = response.data.nombre
            this.datos.punto_venta.mensaje_pie = response.data.mensaje_pie
            this.datos.punto_venta.comprobante_tipo = response.data.comprobante_tipo
            this.datos.punto_venta.numero = response.data.numero
            this.datos.punto_venta.imagen = response.data.logo
            this.datos.punto_venta.divisa = this.divisas.find(d => d.id_divisa === response.data.divisa.id_divisa).iso_code

            this.datos.domicilio.linea1 = response.data.persona_facturacion.domicilio.linea1
            this.datos.domicilio.linea2 = response.data.persona_facturacion.domicilio.linea2
            this.datos.domicilio.localidad = response.data.persona_facturacion.domicilio.localidad
            this.datos.domicilio.codigo_postal = response.data.persona_facturacion.domicilio.codigo_postal
            this.datos.domicilio.pais = response.data.persona_facturacion.domicilio.provincia.pais.id_pais
            this.datos.domicilio.provincia = response.data.persona_facturacion.domicilio.provincia.id_provincia

            this.datos.persona.razon_social = response.data.persona_facturacion.razon_social
            this.datos.persona.fisica = response.data.persona_facturacion.fisica ? 1 : 0
            this.datos.persona.telefono = response.data.persona_facturacion.telefono
            this.datos.persona.movil = response.data.persona_facturacion.movil
            this.datos.persona.documento_numero = response.data.persona_facturacion.documento.numero
            this.datos.persona.documento_tipo = response.data.persona_facturacion.documento.tipo.id_documento_tipo
            this.$alerts.pushAlert('mEditionBillingSalesDataEditData', 'updatePuntoVenta', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingSalesDataEditData', 'updatePuntoVenta', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
